module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3AkOD"))).then(() => parcelRequire('d0iPb'));